import React, { memo } from 'react';
import { GoogleMap, LoadScript } from '@react-google-maps/api';
import PropTypes from 'prop-types';

import { enviroment } from '@utils/config';
import mapStyle from './mapStyle';

function Map(props) {
  const { children, containerStyle, center, libraies } = props;
  const options = {
    disableDefaultUI: true,
    styles: mapStyle,
  };

  return (
    <LoadScript googleMapsApiKey={enviroment.mapApiKey} libraries={libraies}>
      <GoogleMap mapContainerStyle={containerStyle} center={center} options={options} zoom={5}>
        {children}
      </GoogleMap>
    </LoadScript>
  );
}

Map.propTypes = {
  containerStyle: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
  }),
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  getMap: PropTypes.func,
  onClick: PropTypes.func,
  onDblClick: PropTypes.func,
  libraies: PropTypes.arrayOf(PropTypes.string),
};

Map.defaultProps = {
  containerStyle: {
    width: '100%',
    height: '100%',
  },
  center: {
    lat: 4.570868,
    lng: -74.297333,
  },
  getMap: null,
  onClick: null,
  onDblClick: null,
  libraies: null,
};

export default memo(Map);
